// ACL (Access Control List)
// Custom hook for take available rights for user by ACL (Access Control List)

type CheckRights = (toCheck: string[], target: string[]) => boolean;
export const checkRights: CheckRights = (toCheck, target) => {
  if (target.length === 0) return false;

  return target.every((v) => toCheck.includes(v));
};

// export const useACL = (rights: BusinessFeatureDtoAU[]): boolean => {
//   const authoritiesList = useAppSelector(authoritiesListSelector);
//
//   const isAvailable = checkRights(authoritiesList || [], rights);
//
//   // Возможно стоит добавить мапку для ручной установки прав
//   // Или для набора пресетов
//
//   return isAvailable;
// };

/**
 * Usage
 *
 * const isAvailable = useACL(['VIEW_CURRENCY_PROVIDERS', 'EDIT_FEE_RULES']);
 */
